// QA-1014: open the app's shared Report modal against a notification's ACTOR.
//
// A notification has no "report the notification" backend endpoint, and none is
// needed — reporting a notification means reporting the person who caused it. The
// Report modal is the SAME redux-driven flow every other surface uses (MiniDmDock,
// wheel/segment cards): set the instance (the actor's user id) + location ("USER")
// and open it.
//
// The redux store singleton is `require`d LAZILY inside the function (not imported
// at module top) so that merely importing the notification component tree in a unit
// test never spins up the persisted store — the store is touched only when a user
// actually clicks Report.
import {
  setReportInstance,
  setReportLocation,
  setReportModalOpen,
} from '../../redux/actions';

export function openReportForActor(actorUserId) {
  if (actorUserId == null) return;
  // eslint-disable-next-line global-require
  const { store } = require('../../redux');
  store.dispatch(setReportInstance(actorUserId));
  store.dispatch(setReportLocation('USER'));
  store.dispatch(setReportModalOpen(true));
}

export default openReportForActor;
